import React from 'react';
import AppBar from "../../../Components/header/index";
// import AppProvider from "../../../Components/bootstrap"
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Card';
import { makeStyles } from "@material-ui/core/styles";
// import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { useEnhancedAppointmentData, useAppointment } from "./../hooks"
import Chip from '@material-ui/core/Chip';
import moment from 'moment'
// import Profile from "../../../images/profile.png"
// import {useRedirect} from "react-admin";

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: "#F7F7F7",
    }
  },
  Avatar: {
    height: "35px"
  }
}));
export default function Schedule({ handleSubmit,
  reset,
  submitting,
  pristine,
  values,
  signUpGoogle,
  signUpGoogleFailure,
  props,
  ...rest }) {
  const classes = useStyles();
  const appointmentData = useEnhancedAppointmentData()
  const {confirmAppointment} = useAppointment()

  return (
    <div className={classes.div}  >
      <AppBar />
      <div style={{ paddingLeft: "4%", paddingRight: "4%", }}>
      <Paper style={{ padding: "15px", boxShadow: "none", }}>
        <Typography variant="subtitle2" style={{ textAlign: "center", fontSize: "24px" }}>Appointment Details</Typography>

        <Typography varinat="h6" style={{ marginTop: "15px" }}>Attendes ({appointmentData.attendees.length})</Typography>
        <Typography variant="body2" style={{ marginTop: "10px", opacity: "0.7" }}>
          {appointmentData.attendeesData.loaded ? appointmentData.attendeesData.data.map(attendee => <Chip variant="outlined" size="small" key={attendee.objectId} label={attendee.username} />) : "Loading.."}
        </Typography>

        <Typography varinat="h6" style={{ marginTop: "12px" }}>Appointment Date</Typography>
        <Typography variant="body2" style={{ marginTop: "8px", opacity: "0.7" }}>
          {appointmentData.date? moment(appointmentData.date).format("dddd, MMMM Do YYYY, h:mm a"):"Loading..."}
                 </Typography>

        <Typography varinat="h6" style={{ marginTop: "12px" }}>Appointment Duration</Typography>
        <Typography variant="body2" style={{ marginTop: "8px", opacity: "0.7" }}>
          {appointmentData.duration} mins
                 </Typography>
        <Divider inline style={{ marginTop: "8px", padding: "1px" }} />

        <Typography varinat="h6" style={{ marginTop: "15px" }}>Request Message</Typography>
        <Typography variant="body2" style={{ marginTop: "8px", opacity: "0.7" }}>
          {appointmentData.requestMessage}
        </Typography>
        <Grid container style={{ marginTop: "10vh" }}>
          <Grid item xs={6}>
            <Button
              style={{ background: "#D14002", color: "white", borderRadius: "5px", padding: "5px  ", width: "100px" }}
              onClick={() => { }}>
              Cancel
                    </Button>
          </Grid>
          <Grid item xs={6} >
            <Button onClick={()=>confirmAppointment()} style={{ background: "#0288D1", color: "white", borderRadius: "5px", float: "right", padding: "5px  ", width: "90px" }}

            >

              Next
                </Button>
          </Grid>

        </Grid>
      </Paper>
      </div>
    </div>
  );
}
